import styled from 'styled-components';
import { palette } from 'styled-tools';

import { ROW_DIVIDER } from '../GuideRow/styles';

export const Wrapper = styled.div<{ $hasTopDivider?: boolean }>`
	border-top: ${p => (p.$hasTopDivider ? ROW_DIVIDER : '0')};
	margin: 0 auto;
	// iOS stacks the hairline, the list and the footer on one 20pt rhythm. Masterclass rows keep the
	// layout they had.
	padding-top: ${p => (p.$hasTopDivider ? '20px' : '0')};
`;

export const Divider = styled.div<{
	isExtended: boolean;
}>`
	background: rgba(255, 255, 255, 0.8);
	height: 1px;
	width: ${p => (p.isExtended ? '100%' : '40px')};
	margin: 24px auto;
`;

// iOS CatalogDetailFooter: footnote class (12pt medium) with an 8pt inset on top of the 20pt
// stack spacing that separates it from the last row.
export const Footer = styled.p`
	color: ${palette('white')};
	font-size: 12px;
	font-weight: 500;
	margin: 28px 0 0;
`;
